// extracted by mini-css-extract-plugin
export default {"container":"UE-z","title":"VE-z","link":"WE-z"};